export const workInfo = [
    {
        company: "Ramp",
		position: "Software Engineer Intern",
		location: "New York City, NY",
		date: "May 2026 - Present",
		link: "http://ramp.com/",
		bullets: [
            "Increased accepted business applications by <b>10%</b> by building a multi-user app supporting four applicant types, simultaneous editing, and permission transfers for <b>5,000+ businesses</b> applying monthly using <b>Python</b> and <b>React</b>",
            "<b>Reduced latency by 67%</b> by migrating a scoring pipeline that prioritizes high-prospect customers for sales-assisted onboarding from <b>Celery</b> to <b>Temporal</b> to support parallelization and failure-handling policies using <b>Python</b>"
        ]
    },
    {
		company: "Harvey",
		position: "Software Engineer Intern",
		location: "San Francisco, CA",
		date: "May 2025 - Aug 2025",
		link: "https://harvey.ai/",
		bullets: [
            "Developed internal tools that streamlined engineering workflows at a <b>5B+ USD</b> unicorn startup, reducing cross-team friction and cutting manual work by <b>6+ hours daily</b> using <b>Flask</b>, <b>JavaScript</b>, <b>Kubernetes</b> and <b>Microsoft Azure</b>",
			"<b>Accelerated turnaround time by 70%</b> by architecting an automation pipeline that provides engineers with self-service access to run Kubernetes Jobs and database migration scripts in staging and production using <b>Python</b>",
			"<b>Reduced deployment rollbacks by 25%</b> by orchestrating a tool for engineers to update secrets in Azure Key Vaults and auto-generate GitHub pull requests to update secret versions in the codebase using <b>Flask</b> and <b>JavaScript</b>",
			"<b>Minimized escalations to user operation specialists by 40%</b> by building a <a href='https://ping.harvey.ai' target='_blank'>web app</a> that pings internal Harvey endpoints and websockets to debug firewall and network issues for <b>500+ clients</b> across <b>50+ countries</b>"	
        ]
    },
	{
		company: "PointClickCare",
		position: "Software Engineer Intern",
		location: "Kitchener, ON",
		date: "Jan 2025 - Apr 2025",
		link: "https://pointclickcare.com/",
		bullets: [
			"Developed care management services for a <b>CAD 5B+</b> unicorn startup, reaching <b>2.7M+ users</b> by implementing web features, optimizing database performance, and writing automated E2E tests using <b>React</b>, <b>Cypress</b>, and <b>SQL</b>.",
			"Led the development of a care plan mapping service that adds goals/tasks to patient profiles by handling <b>4700+ PostgreSQL entries</b>, adjusting user permissions, and cutting API latency by <b>700ms</b> using <b>JavaScript</b> and <b>Java</b>",
			"Increased <b>code coverage to 83%</b> by writing <b>10+ TestNG unit tests</b> to validate JavaScript logic and data retrieval",
            "Built a <b>React</b> feature for annotating human body diagrams with <b>50 health issues</b> by updating user responses asynchronously with Promises, filtering <b>50+ dynamic controls</b> and supporting <b>3 user modes</b> using <b>Typescript</b>",
            "Eliminated <b>95% of manual labour</b> by automating node package upgrades across <b>3 microservices</b> using <b>Bash</b>"
        ]
	},
	{
		company: "Rich Media",
		position: "Software Developer Intern",
		location: "Toronto, ON",
		date: "May 2024 - Aug 2024",
		link: "https://www.richmedia.com/",
		bullets: [
			"Developed responsive financial literacy web apps for <b>10+ million users</b> that collect user information, perform mathematical computation, and generate PDF documents with customized graphical representations",
			"Increased <b>code coverage to 80%+</b> for a property/mortgage protection web app by writing and integrating <b>10+ Cypress E2E tests</b> into a <b>Jenkins server framework</b> for automated regression testing and continuous integration",
			"Enhanced accessibility compliance for <b>150+ digital literacy articles</b> by implementing <b>ARIA features</b> and conducting auditing to ensure compatibility with keyboard navigation and <b>non-visual desktop access (NVDA)</b> standards",
			"Achieved data quality for <b>5+ mortgage protection platforms</b> by generating mathematical formulas, computing affordability based on user input, and cross-referencing data outputs with <b>30+ verified test cases</b> using <b>TypeScript</b>",
			"Decreased <b>playback latency by 30%</b> for <b>5 dynamic videos</b> by decoding video frames onto a canvas for user customization, then encoding frames for rendering using <b>MP4Box</b>, <b>MP4-Muxer</b>, and <b>WebCodecs API</b>"
		]
	},
	{
		company: "FIRST Robotics",
		position: "Software Developer",
		location: "Ottawa, ON",
		date: "Sept 2019 - August 2023",
		link: "https://www.team2706.ca/",
		bullets: [
			"Led the development of a robot vision system that recognizes <b>8 unique objects</b> and tracks their <b>XYZ coordinates</b>",
			"Increased <b>execution accuracy by 60%</b> during provincial robotics competitions by calculating the surface area of identified objects to derive the robot's relative distance using <b>Python</b>, <b>OpenCV libraries</b>, and <b>pose estimation</b>",
			"Provided accessible coding workshops and hosted robotics demonstrations for <b>6000+ STEM students</b> in Ottawa"
		]
	},
	{
		company: "CoderSports",
		position: "Software Mentor",
		location: "Ottawa, ON",
		date: "Jun 2021 - Aug 2021",
		link: "https://codersports.com/",
		bullets: [
			"Mentored <b>20+ students</b> in programming by creating lesson plans, organizing hackathons, and offering hands-on guidance",
			"Documented <b>5+ processes</b> for solving data structure and algorithm problems by creating step-by-step coding tutorials for students to learn <b>Python</b>",
			"Collaborated with <b>3+ mentors</b> to create an interactive project demonstration using <b>JavaScript</b>, <b>HTML</b> and <b>CSS</b>"
		]
	}
];
